import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import i18n from '~/i18n'
import textFunctions from '~/Classes/textFunctions'
class FormOverview extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        var create = ''
        let createComponent = null
        if (this.props.form.options.onCreate === 'replace') create = i18n.t('form:edit.overview.createReplace')
        if (this.props.form.options.onCreate === 'redirect') {
            create = i18n.t('form:edit.overview.createRedirect', {
                url: textFunctions.checkForHtml(this.props.form.options.createRedirectUrl)
            })
        }
        if (this.props.form.options.onCreate === 'message') {
            create = i18n.t('form:edit.overview.createMessage', {
                message: textFunctions.checkForHtml(this.props.form.options.createMessage)
            })
        }
        if (this.props.form.options.onCreate === 'hide') {
            create = i18n.t('form:edit.overview.createHide', {
                message: textFunctions.checkForHtml(this.props.form.options.createMessage)
            })
        }

        var update = ''
        if (this.props.form.options.onUpdate === 'replace') update = i18n.t('form:edit.overview.updateReplace')
        if (this.props.form.options.onUpdate === 'redirect')
            update = i18n.t('form:edit.overview.updateRedirect', {
                url: textFunctions.checkForHtml(this.props.form.options.updateRedirectUrl)
            })
        if (this.props.form.options.onUpdate === 'message')
            update = i18n.t('form:edit.overview.updateMessage', {
                message: textFunctions.checkForHtml(this.props.form.options.updateMessage)
            })
        if (this.props.form.options.onUpdate === 'update') update = i18n.t('form:edit.overview.updateUpdate')

        var confirm = ''
        if (this.props.form.options.onConfirm === 'landing') confirm = i18n.t('form:edit.overview.confirmedLanding')
        if (this.props.form.options.onConfirm === 'redirect')
            confirm = i18n.t('form:edit.overview.confirmedLanding', {
                url: textFunctions.checkForHtml(this.props.form.options.confirmedRedirectUrl)
            })

        return (
            <Paper>
                <div className='text-md mar-b5'>People who submit this form will be added to the following group:</div>
                <div className='mar-b25 text-md text-secondary text-heavy '>{this.props.group.groupName}</div>
                <Button
                    className='mar-b25'
                    text={i18n.t('form:edit.overview.change')}
                    onClick={this.props.changeGroup}
                    iconLeft={<Icons icon='pencil' />}
                />
                <div className='divider2'></div>
                <div className='mar-b25 text-md ' dangerouslySetInnerHTML={{ __html: create }}></div>
                <Button
                    className='mar-b25'
                    text={i18n.t('form:edit.overview.change')}
                    onClick={() => this.props.change(1)}
                    iconLeft={<Icons icon='pencil' />}
                />
                <div className='divider2'></div>
                <div className='mar-b25 text-md ' dangerouslySetInnerHTML={{ __html: update }}></div>
                <Button
                    className='mar-b25'
                    text={i18n.t('form:edit.overview.change')}
                    onClick={() => this.props.change(2)}
                    iconLeft={<Icons icon='pencil' />}
                />
                <div className='divider2'></div>
                <div>
                    {!!this.props.form.sendConfirmation && (
                        <>
                            <div
                                className='mar-b25 text-md '
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('form:edit.overview.confirm', {
                                        name: textFunctions.checkForHtml(this.props.form.confirmationName),
                                        email: textFunctions.checkForHtml(this.props.form.confirmationEmail),
                                        subject: textFunctions.checkForHtml(this.props.form.confirmationSubject)
                                    })
                                }}
                            />
                            <Button
                                className='mar-b25'
                                text={i18n.t('form:edit.overview.change')}
                                onClick={this.props.editEmail}
                                iconLeft={<Icons icon='pencil' />}
                            />
                        </>
                    )}
                    {!this.props.form.sendConfirmation && (
                        <>
                            <div className='mar-b25 text-md '>You have set it to not send confirmation emails</div>
                            <Button className='mar-b25' text='Enable' onClick={this.props.enableConfirmation} />
                        </>
                    )}
                </div>
                {this.props.form.sendConfirmation == true && <div className='divider2'></div>}
                {this.props.form.sendConfirmation == true && (
                    <div>
                        <div className='mar-b25 text-md ' dangerouslySetInnerHTML={{ __html: confirm }}></div>

                        <Button
                            className='mar-b25'
                            text={i18n.t('form:edit.overview.change')}
                            onClick={() => this.props.change(4)}
                            iconLeft={<Icons icon='pencil' />}
                        />
                    </div>
                )}
            </Paper>
        )
    }
}

export default FormOverview
